import React, { useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { TextHighlighted } from '@playbookux/playbook-web-core';
import Card from '../../card-highlight';
import TestTypes from '../../../constants/testTypes';
import { formatEntityType } from '../../../utils/format-entity-type';

const TranscriptCard = (props) => {
  const {
    handleClick,
    isSelectable,
    highlight,
    onCardClick,
    selected,
    searchHighlights,
  } = props;

  const [showPreview, setShowPreview] = useState(false);

  const {
    searchable,
    searchableType: entityType,
  } = highlight || {};

  const {
    createdAt,
    testSession: { tester = {} },
    tagHighlights,
    noteType,
    question,
    speakerTag,
    transcriptText: textAnswer = null,
    text: textSpeaker = null,
    videoStartTime = null,
  } = searchable;

  const questionOrder = _.get(question, 'questionOrder', null);
  const firstName = _.get(tester, 'user.profile.firstName', '');
  const projectId = _.get(tester, 'project.id', '');
  const testType = _.get(tester, 'project.testType', '');
  const projectName = _.get(tester, 'project.name', '');
  const testerId = _.get(tester, 'id', '');

  const url = `projects/${projectId}/videos/${testerId}?time=${videoStartTime}`;
  const cardType = formatEntityType(entityType, noteType);

  const handleShowPreviewText = () => {
    setShowPreview((prev) => !prev);
  };

  return (
    <Card
      cardType={cardType}
      createdAt={createdAt}
      isSelectable={isSelectable}
      onCardClick={onCardClick}
      onClick={() => handleClick('entityId', entityType, url)}
      projectName={projectName}
      selected={selected}
      tagHighlights={tagHighlights}
      userName={firstName}
    >
      {questionOrder !== null && testType === TestTypes.UNMODERATED
        && <div>{`Question: ${parseInt(questionOrder, 10) + 1}`}</div>}

      {speakerTag !== null && testType === TestTypes.MODERATED
        && <div>{`Speaker: ${speakerTag}`}</div>}

      <TextHighlighted
        tagHighlights={tagHighlights || []}
        text={textAnswer || textSpeaker || ''}
        searchHighlights={searchHighlights}
        showPreview={showPreview}
        onShowPreviewText={handleShowPreviewText}
      />
    </Card>
  );
};

TranscriptCard.propTypes = {
  handleClick: PropTypes.func,
  isSelectable: PropTypes.bool,
  onCardClick: PropTypes.func,
  searchHighlights: PropTypes.arrayOf(PropTypes.shape({
    charEnd: PropTypes.number,
    charStart: PropTypes.number,
    text: PropTypes.string,
  })),
  selected: PropTypes.bool.isRequired,
  highlight: PropTypes.shape({
    searchable: PropTypes.shape({
      createdAt: PropTypes.string,
      __typename: PropTypes.string,
      testSession: PropTypes.shape({
        tester: PropTypes.shape({
          user: PropTypes.shape({
            profile: PropTypes.shape({
              firstName: PropTypes.string,
            }),
          }),
          project: PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
          }),
        }),
      }),
      note: PropTypes.string,
      tagHighlights: PropTypes.oneOfType([PropTypes.array]),
      noteType: PropTypes.string,
      speakerTag: PropTypes.string,
      transcriptText: PropTypes.string,
      text: PropTypes.string,
      question: PropTypes.shape({
        id: PropTypes.string,
        questionOrder: PropTypes.number,
      }),
    }),
    searchableType: PropTypes.string,
    projectId: PropTypes.string,
  }),
};

TranscriptCard.defaultProps = {
  handleClick: null,
  isSelectable: false,
  searchHighlights: [],
  highlight: PropTypes.shape({
    searchable: PropTypes.shape({
      createdAt: '',
      __typename: '',
      testSession: PropTypes.shape({
        tester: PropTypes.shape({
          user: PropTypes.shape({
            profile: PropTypes.shape({
              firstName: '',
            }),
          }),
          project: PropTypes.shape({
            id: '',
            name: '',
          }),
        }),
      }),
      note: '',
      tagHighlights: [],
      noteType: '',
      question: PropTypes.shape({
        id: '',
        questionOrder: null,
      }),
    }),
    searchableType: '',
    projectId: '',
  }),
  onCardClick: () => { },
};

export default TranscriptCard;
